/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';
import { addToNewsLetterWelcomeOffer_Len_CAPAsync } from '../../actions/DataActionExtension.g';
import { IEmailVerificationViewProps } from './email-verification';
import {
    getSiteLanguageConfigFromContext,
    determineSiteLanguageForAbandonedCart
} from '../../themes/venchi-v2-1/utils/determineSiteLanguageForAbandonedCart';

const EmailVerificationView: React.FC<IEmailVerificationViewProps> = props => {
    const siteLanguageConfig = getSiteLanguageConfigFromContext(props.context);
    const locale = determineSiteLanguageForAbandonedCart(siteLanguageConfig);

    // TODO: enable loyalty flow
    const source = props?.config?.source || '';
    const channelId: number = props.context.request.apiSettings.channelId;
    const requestParams = props.context.request.query;
    const email = requestParams?.email;
    const token = requestParams?.token;
    let message = props.resources.emailVerificationSuccessMessage;
    const [loading, setLoading] = React.useState(false);
    const [subscribeMessage, setSubscribeMessage] = React.useState({
        state: false,
        message: '',
        class: ''
    });
    React.useEffect(() => {
        if (email && token) {
            setLoading(true);
            // TODO: enable loyalty flow
            addToNewsLetterWelcomeOffer_Len_CAPAsync(
                { callerContext: props.context?.actionContext },
                channelId,
                email,
                token,
                locale,
                source
            )
                .then(result => {
                    // message = result[0].Error ? result[0].Error : message;
                    setLoading(false);
                    if (result.Status) {
                        setSubscribeMessage({
                            state: true,
                            message: message,
                            class: 'success'
                        });
                    } else {
                        message = result.Error ? result.Error : '';
                        switch (message) {
                            case 'token-email_notValid':
                                message = props.resources.tokenEmailNotValid;
                                break;
                            case 'registerToCRM_error':
                                message = props.resources.registerToCrmError;
                                break;
                            case 'SendCoupon_error':
                                message = props.resources.sendCouponError;
                                break;
                            case 'already_confirmed':
                                message = props.resources.emailAlreadyConfirmed;
                                break;
                            case 'already_subscribed':
                                message = props.resources.alreadySubscribedText;
                                break;
                            default:
                            // code block
                        }
                        setSubscribeMessage({
                            state: true,
                            message: message,
                            class: 'error'
                        });
                    }
                })
                .catch(error => {
                    message = error.message;
                    setSubscribeMessage({
                        state: true,
                        message: error.message,
                        class: 'error'
                    });
                });
        }
    }, []);
    return (
        <div className={props.className} id={props.id} {...props.renderModuleAttributes(props)}>
            {props.paragraph}
            {loading ? (
                <div className={`msc-alert msc-alert-success`}>
                    <div className={'loading'} />
                </div>
            ) : (
                ''
            )}
            {subscribeMessage.state ? (
                <div className={`msc-alert msc-alert-${subscribeMessage.class}`} role='alert'>
                    {subscribeMessage.message}
                </div>
            ) : (
                ''
            )}
        </div>
    );
};

export default EmailVerificationView;
